import { put } from "redux-saga/effects";
import { message } from "antd";
import { ApiCaller } from "../../config";
import { UniversityAction } from "../actions";
import { DefaultNotification } from "../../components";

export default class UniversityMiddleware {
  static *addUniversity({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post(`/university/add-university`, payload);

      if (res.status === 200) {
        yield put(UniversityAction.addUniversitySuccess(res.data.data));
        DefaultNotification(res?.data?.message, "success", "top");
      } else {
        yield put(UniversityAction.addUniversityFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.addUniversityFailure());
    }
  }
  static *addUniversitySheet({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post(
        `/university/add-university-sheet`,
        payload
      );

      if (res.status === 200) {
        yield put(UniversityAction.addUniversitySheetSuccess(res.data.data));
        const fileContent =
          typeof res.data.data === "string"
            ? res.data.data
            : JSON.stringify(res.data.data, null, 2);
        const blob = new Blob([fileContent], { type: "text/plain" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "log.txt";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else {
        yield put(UniversityAction.addUniversitySheetFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.addUniversitySheetFailure());
    }
  }
  static *editUniversity({ payload, cb }) {
    try {
      const res = yield ApiCaller.Put(`/university/edit-university`, payload);

      if (res.status === 200) {
        yield put(UniversityAction.editUniversitySuccess(res.data.data));
        DefaultNotification(res?.data?.message, "success", "top");
      } else {
        yield put(UniversityAction.editUniversityFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.editUniversityFailure());
    }
  }
  static *uploadUniImage({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post(
        `/university/upload-uni-profile-images-bulk`,
        payload
      );

      if (res.status === 200) {
        yield put(UniversityAction.uploadUniImageSuccess(res.data.data));
        DefaultNotification(res?.data?.message, "success", "top");
      } else {
        yield put(UniversityAction.uploadUniImageFailure());
        message.error(res.data.message);
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.uploadUniImageFailure());
    }
  }
  static *getUniversities({ payload, cb }) {
    try {
      const {
        search,
        limit,
        offset,
        region,
        areaOfStudy,
        majors,
        budget,
        scholarships,
        tag,
        sortby,
      } = payload;

      const res = yield ApiCaller.Get(
        `/university/search-university?search=${search ?? ""}&budget=${
          budget ?? ""
        }&limit=${limit ?? ""}&offset=${offset ?? ""}&region=${
          region ?? ""
        }&areaOfStudy=${areaOfStudy ?? ""}&majors=${
          majors ?? ""
        }&scholarships=${scholarships ?? ""}&tag=${tag ?? ""}&sortby=${
          sortby ?? "qs"
        }&portal=admin`
      );

      if (res.status === 200) {
        yield put(UniversityAction.getUniversitiesSuccess(res.data.data));
      } else {
        yield put(UniversityAction.getUniversitiesFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.getUniversitiesFailure());
    }
  }
  static *getUniversitiesGrid({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/university/grid-view-results`);
      if (res.status === 200) {
        yield put(UniversityAction.getUniversitiesGridSuccess(res.data.data));
      } else {
        yield put(UniversityAction.getUniversitiesGridFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.getUniversitiesGridFailure());
    }
  }
  static *getAllUniversities({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/university/getAllUniversities`);
      if (res.status === 200) {
        yield put(UniversityAction.getAllUniversitiesSuccess(res.data.data));
      } else {
        yield put(UniversityAction.getAllUniversitiesFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.getAllUniversitiesFailure());
    }
  }
  static *getUnisByBudget({ cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/university/getTotalUniversitiesByBudget`
      );
      if (res.status === 200) {
        yield put(UniversityAction.getUnisByBudgetSuccess(res.data.data));
      } else {
        yield put(UniversityAction.getUnisByBudgetFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.getUnisByBudgetFailure());
    }
  }
  static *getPopularCountries({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/university/getPopularCountries`);
      if (res.status === 200) {
        yield put(UniversityAction.getPopularCountriesSuccess(res.data.data));
      } else {
        yield put(UniversityAction.getPopularCountriesFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.getPopularCountriesFailure());
    }
  }
  static *getUniversityDetails({ id, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/university/get-university-details/${id}`
      );
      if (res.status === 200) {
        yield put(UniversityAction.getUniversityDetailsSuccess(res.data.data));
      } else {
        yield put(UniversityAction.getUniversityDetailsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.getUniversityDetailsFailure());
    }
  }
  static *getUniversityDetailsAdmin({ id, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/university/get-university-details-admin/${id}`
      );
      if (res.status === 200) {
        yield put(
          UniversityAction.getUniversityDetailsAdminSuccess(res.data.data)
        );
      } else {
        yield put(UniversityAction.getUniversityDetailsAdminFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.getUniversityDetailsAdminFailure());
    }
  }
  static *getUniAppsShorts({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/university/get-university-apps-and-shortlists?schoolId=${payload?.schoolId}&universityId=${payload?.universityId}`
      );
      if (res.status === 200) {
        yield put(UniversityAction.getUniAppsShortsSuccess(res.data.data));
      } else {
        yield put(UniversityAction.getUniAppsShortsFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(UniversityAction.getUniAppsShortsFailure());
    }
  }
}
